module.exports = __webpack_public_path__ + "img/programme8.48de0749.png";